module.exports = __webpack_public_path__ + "static/6-7f1216e0c3ce4216e391c82907648fdd.jpg";